const apiKey = "b2a5adcct04b33178913oc335f405433";

function formatDate(date) {
  let minutes = date.getMinutes();
  let hours = date.getHours();
  let day = date.getDay();

  if (minutes < 10) {
    minutes = `0${minutes}`;
  }

  if (hours < 10) {
    hours = `0${hours}`;
  }

  let days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  let formattedDay = days[day];
  return `${formattedDay} ${hours}:${minutes}`;
}

function formatTime(date) {
  let minutes = date.getMinutes();
  let hours = date.getHours();

  if (minutes < 10) {
    minutes = `0${minutes}`;
  }

  if (hours < 10) {
    hours = `0${hours}`;
  }

  return `${hours}:${minutes}`;
}

function formatApiTime(value) {
  if (!value) {
    return "--";
  }

  const date =
    typeof value === "number" ? new Date(value * 1000) : new Date(value);
  return isNaN(date.getTime()) ? "--" : formatTime(date);
}

function showError(message) {
  const errorElement = document.querySelector("#error");
  errorElement.innerHTML = message;
}

function displayTemperature(response) {
  const data = response.data;

  document.querySelector("#current-city").innerHTML = data.city || "--";
  document.querySelector("#current-temperature").innerHTML =
    data.temperature?.current != null
      ? `${Math.round(data.temperature.current)}°`
      : "--";
  document.querySelector("#description").innerHTML =
    data.condition?.description || "--";
  document.querySelector("#humidity").innerHTML =
    data.temperature?.humidity != null
      ? Math.round(data.temperature.humidity)
      : "--";
  document.querySelector("#wind").innerHTML =
    data.wind?.speed != null ? Math.round(data.wind.speed) : "--";
  document.querySelector("#current-date").innerHTML = formatDate(new Date());
  document.querySelector("#time").innerHTML = formatTime(new Date());
  document.querySelector("#sunrise").innerHTML = formatApiTime(
    data.sunrise || data.daily?.sunrise?.[0],
  );
  document.querySelector("#sunset").innerHTML = formatApiTime(
    data.sunset || data.daily?.sunset?.[0],
  );
  document.querySelector("#rain").innerHTML =
    data.rain?.["1h"] ?? data.rain ?? "0";
  document.querySelector("#aqi").innerHTML = data.air_quality?.aqi ?? "--";
  document.querySelector("#tips").innerHTML = data.condition?.description
    ? `Weather is ${data.condition.description.toLowerCase()}. Dress appropriately!`
    : "Check the weather conditions.";
  showError("");
}

function search(event) {
  event.preventDefault();

  const searchInputElement = document.querySelector("#search-input");
  const city = searchInputElement.value.trim();

  if (!city) {
    showError("Please enter a city name.");
    return;
  }

  const apiUrl = `https://api.shecodes.io/weather/v1/current?query=${encodeURIComponent(city)}&key=${apiKey}&units=metric`;

  axios
    .get(apiUrl)
    .then(displayTemperature)
    .catch(() => showError("Unable to fetch weather. Try another city."));
}

function searchLocation(position) {
  const latitude = position.coords.latitude;
  const longitude = position.coords.longitude;
  const apiUrl = `https://api.shecodes.io/weather/v1/current?lon=${longitude}&lat=${latitude}&key=${apiKey}&units=metric`;

  axios
    .get(apiUrl)
    .then(displayTemperature)
    .catch(() => showError("Unable to fetch weather from your location."));
}

function getCurrentLocation() {
  if (!navigator.geolocation) {
    showError("Geolocation is not supported by your browser.");
    return;
  }

  navigator.geolocation.getCurrentPosition(searchLocation, () =>
    showError("Unable to access location."),
  );
}

const searchForm = document.querySelector("#search-form");
searchForm.addEventListener("submit", search);

const locationButton = document.querySelector("#locationBtn");
locationButton.addEventListener("click", getCurrentLocation);

const currentDateElement = document.querySelector("#current-date");
const currentTimeElement = document.querySelector("#time");
const now = new Date();
currentDateElement.innerHTML = formatDate(now);
currentTimeElement.innerHTML = formatTime(now);
